let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f8hA7")).then(() => parcelRequire('dYxhu'));